import { useGlobalErrorContext } from "context/globalErrorContext";

export const useOpenGlobalErrorModal = () => {
	const {
		actions: { openErrorModal }
	} = useGlobalErrorContext();

	return openErrorModal;
};
